/*
  tslint:disable:import-spacing component-class-suffix
  no-inferrable-types variable-name typedef-whitespace component-selector
  no-trailing-whitespace
*/

import {
  AfterViewInit,
  Component,
  HostListener,
  Input
} from '@angular/core';

import {TrainClass}    from '@/models/scenario/train.class';
import {Train}         from '@/models/scenario/train';
import {Stop}          from '@/models/scenario/stop';
import {StopEvent}     from '@/models/scenario/stop.event';

import {
  Scenario,
  TrainStopEntry,
  TrainStopReport
}                      from '@/models/scenario/scenario';
import {Logger}        from '@/util/logger';
import {StatusReporter} from "@/util/status.reporter";

import * as $ from 'jquery';

import 'bootstrap'
import 'bootstrap-select';

import  'ag-grid-community';

import {
  GridApi,
  GridReadyEvent,
  GetContextMenuItemsParams
} from "ag-grid-community";



@Component({
  selector: 'dwell-table',
  template: `

    <div style="float: left; display: block; margin-top: 4px; margin-bottom: 4px;">
      <label style="float: left; display: block; margin-right: 12px; margin-top: 3px; margin-left: 16px;">Train:</label>
      <div id="train-picker-wrapper_{{uuid}}" class="train-picker-wrapper" style="float: left; display: block; width: 800px;">
        <select id="dwell-train-picker_{{uuid}}" class="train-picker dwell-train-picker form-control">
          <option value="0" data-id="0" selected="selected">Please Select</option>
        </select>
      </div>
    </div>

    <div id="dwell-table-container_{{uuid}}" class="dwell-table-container" style="">
      <ag-grid-angular id="ag-grid-dwell-table_{{uuid}}" style="width: 100%; height: 100%;"
        class="ag-theme-balham-dark ag-grid-dwell-table"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [context]="context"
        [animateRows]="true"
        [enableRangeSelection]="true"

        [allowContextMenuWithControlKey]="true"
        [getContextMenuItems]="getContextMenuItems"

        (gridReady)="onGridReady($event)"
      >
      </ag-grid-angular>
    </div>
    `
})

/**
 *
 * @class DwellTable
 *
 * @brief @brief this table shows the total expected stop times for a train at all decision points.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class DwellTable implements AfterViewInit {

  @Input() uuid: number                 = 0;

  /** @var _scenario the scenario model */

  private    _scenario: Scenario        = null;

  /** the API for the widget */
  private          api: GridApi         = null;

  private isFullScreen: boolean         = false;

  /** where we are sending our status messages */
  public statusReporter: StatusReporter = null;

  public context = {

    dwellTable: this

  };

  public columnDefs: any[] = [

    {
      headerName: 'Decision Point',
      children: [
        {headerName: 'ROW',         field: 'row',      hide: true},
        {headerName: 'Mileage',     field: 'mileage',  editable: true, width: 150},
        {headerName: 'Name',        field: 'name',     editable: true, width: 150, columnGroupShow: 'open'},
        {
          headerName: 'Type',
          field: 'type',
          editable: true,
          width: 50,
          cellEditor: 'agSelectCellEditor',
          cellEditorParams: {
            values: ['S', 'D', 'P', 'T', 'J']
          },
          columnGroupShow: 'open'
        }
      ]
    }

    /* on init no speed groups, we don't know how many there are yet */

  ];

  public defaultColDef = {
    sortable:  true,
    filter:    true,
    resizable: true
  };

  public rowData = [];

  constructor(
  ) {

  }

  /** update the error line in the loader drop down */
  public success(msg: string =  '') {

    if (this.statusReporter === null) {

      return ;
    }

    this.statusReporter.success(msg);
  }

  /** update the error line in the loader drop down */
  public error(msg: string =  '') {

    if (this.statusReporter === null) {

      return ;
    }

    this.statusReporter.error(msg);
  }

  public onGridReady(params: GridReadyEvent): void {

    this.api       = params.api;
  }

  public toggleFullScreen() {

    if (this.isFullScreen) {

      Logger.debug('[dwell/table]', 'exiting full screen...');

      document.exitFullscreen();

    } else {

      Logger.debug('[dwell/table]', 'going full screen...');

      const elem = document.getElementById(`ag-grid-dwell-table_${this.uuid}`);

      if (elem.requestFullscreen) {

        elem.requestFullscreen();
      }
    }

  }

  public getContextMenuItems(params: GetContextMenuItemsParams): any {

    const context: any[] = [];
    const gcDwellTable  = params.context.dwellTable;

    if (context.length !== 0) {

      context.push('separator');
    }

    /* full screen control */

    let label: string = 'Show Full Screen';

    if (gcDwellTable.isFullScreen) {

      label = 'Exit Full Screen';
    }

    context.push( {
      name: label,
      action: () => {

        gcDwellTable.toggleFullScreen();
      }
    });

    context.push('separator');

    const general: any[] = [

      'copy',
      'copyWithHeaders',
      'paste',

      'separator',

      'expandAll',
      'contractAll',

      'separator',

      'csvExport',
      'excelExport',
      'excelXmlExport',

      'separator',

      'autoSizeAll'
    ];

    /* pass back the merged menu */

    context.push.apply(context, general);

    return context;
  }

  /** @brief first time setup of view */
  ngAfterViewInit() {

    Logger.debug('[dwell/table]', 'view init...');

    this.clear();

    const elem = document.getElementById(`ag-grid-dwell-table_${this.uuid}`);

    const gcDwellTable = this;

    elem.addEventListener('fullscreenchange', () => {

      gcDwellTable.isFullScreen = document.fullscreenElement != null;

      Logger.debug('[dwell/table]', '(elem) flipped full screen mode: ', gcDwellTable.isFullScreen);

    }, true);
  }

  /** @brief reset the view to empty */
  public clear() {

    this._scenario = null;
  }

  /** @brief standard destructor */
  destroy() {

    Logger.debug('[dwell/table]', 'cleaning up...');

  }

  /** @brief check if this train has any stops/stop time */
  trainHasStops(train: Train): boolean {

    const stops: TrainStopEntry[] = this._scenario.reportTrainStops(train);

    if (stops.length === 0) {

      /* absolutely no stops. */

      return false;
    }

    /* walk the stop report until we find a stop that has actual non-zero stop time. */

    for (const tse of stops) {

      if (tse.hours > 0) {

        /* found non-zero stop time */
        return true;
      }
    }

    /* failed to find any stop time */

    return false;
  }

  /** @brief set the table base on this scenario */
  setScenario(scenario: Scenario = null): boolean {

    let dwt: DwellTable  = this;
    let selectId: string = `#dwell-train-picker_${dwt.uuid}`;

    if (scenario == null) {

      dwt.clear();

      return true;
    }

    /* save the model */

    dwt._scenario         = scenario;

    const  templates: {
      actual:      [],
      even:        [],
      exponential: [],
      scheduled:   [],
      weekly:      []
    }     = dwt._scenario.reportTrainTemplates();

    /* set up the train template selector, we can't do anything until we can select train templates */

    let html: string = '';

    html = html + `<select data-style="btn-primary" multiple class="train-picker selectpicker form-control" id="dwell-train-picker_${dwt.uuid}">\n`;

    /* actual trains */

    {
      html = html + '<optgroup label="Actual">\n';

      for (const itemTyped of templates.actual) {

        const item: any        = itemTyped;
        let   attr: string     = '';
        const   tc: TrainClass = item.trainClass;
        const  dir: string     = TrainClass.typeToString(tc._dir);

        /* don't allow them to select trains without stops */

        if (!dwt.trainHasStops(dwt._scenario.trainById(item.id))) {

          attr = attr + ' disable ';
          attr = attr + ' data-subtext="No Stop Time" ';
        }

        attr = attr + ' data-type="'    + 'act'     + '"';
        attr = attr + ' data-id="'      + item.id   + '"';
        attr = attr + ' data-name="'    + item.name + '"';
        attr = attr + ' data-tdid="'    + tc._id    + '"';
        attr = attr + ' data-tcname="'  + tc._name  + '"';
        attr = attr + ' data-dir="'     + dir       + '"';

        html = html + '<option ' + attr + ' value="' + item.id +  '">' + item.name + ' (' + dir + ')' + '</option>\n';


      }

      html = html + '</optgroup>\n';
    }

    /* even train */

    {
      html = html + '<optgroup label="Even">\n';

      for (const itemTyped of templates.even) {

        const item: any        = itemTyped;
        let   attr: string     = '';
        const   tc: TrainClass = item.trainClass;
        const  dir: string     = TrainClass.typeToString(tc._dir);

        if (!dwt.trainHasStops(dwt._scenario.trainById(item.id))) {

          attr = attr + ' disabled ';
          attr = attr + ' data-subtext="No Stop Time" ';
        }

        attr = attr + ' data-type="'    + 'evn'     + '"';
        attr = attr + ' data-id="'      + item.id   + '"';
        attr = attr + ' data-name="'    + item.name + '"';
        attr = attr + ' data-tdid="'    + tc._id    + '"';
        attr = attr + ' data-tcname="'  + tc._name  + '"';
        attr = attr + ' data-dir="'     + dir       + '"';

        html = html + '<option ' + attr + ' value="' + item.id +  '">' + item.name + ' (' + dir + ')' + '</option>\n';
      }

      html = html + '</optgroup>\n';
    }

    /* exponential trains */

    {
      html = html + '<optgroup label="Exponential">\n';

      for (const itemTyped of templates.exponential) {

        const item: any        = itemTyped;
        let   attr: string     = '';
        const   tc: TrainClass = item.trainClass;
        const  dir: string     = TrainClass.typeToString(tc._dir);

        if (!dwt.trainHasStops(dwt._scenario.trainById(item.id))) {

          attr = attr + ' disabled ';
          attr = attr + ' data-subtext="No Stop Time" ';
        }

        attr = attr + ' data-type="'    + 'exp'     + '"';
        attr = attr + ' data-id="'      + item.id   + '"';
        attr = attr + ' data-name="'    + item.name + '"';
        attr = attr + ' data-tdid="'    + tc._id    + '"';
        attr = attr + ' data-tcname="'  + tc._name  + '"';
        attr = attr + ' data-dir="'     + dir       + '"';

        html = html + '<option ' + attr + ' value="' + item.id +  '">' + item.name + ' (' + dir + ')' + '</option>\n';

      }

      html = html + '</optgroup>\n';
    }

    /* scheduled trains */

    {
      html = html + '<optgroup label="Scheduled">\n';

      for (const itemTyped of  templates.scheduled) {

        const item: any        = itemTyped;
        let   attr: string     = '';
        const   tc: TrainClass = item.trainClass;
        const  dir: string     = TrainClass.typeToString(tc._dir);

        if (!dwt.trainHasStops(dwt._scenario.trainById(item.id))) {

          attr = attr + ' disabled ';
          attr = attr + ' data-subtext="No Stop Time" ';
        }

        attr = attr + ' data-type="'    + 'sch'     + '"';
        attr = attr + ' data-id="'      + item.id   + '"';
        attr = attr + ' data-name="'    + item.name + '"';
        attr = attr + ' data-tdid="'    + tc._id    + '"';
        attr = attr + ' data-tcname="'  + tc._name  + '"';
        attr = attr + ' data-dir="'     + dir       + '"';

        html = html + '<option ' + attr + ' value="' + item.id +  '">' + item.name + ' (' + dir + ')' + '</option>\n';

      }

      html = html + '</optgroup>\n';
    }

    /* weekly trains */

    {
      html = html + '<optgroup label="Weekly">\n';

      for (const itemTyped of templates.weekly) {

        const item: any        = itemTyped;
        let   attr: string     = '';
        const   tc: TrainClass = item.trainClass;
        const  dir: string     = TrainClass.typeToString(tc._dir);

        if (!dwt.trainHasStops(dwt._scenario.trainById(item.id))) {

          attr = attr + ' disabled ';
          attr = attr + ' data-subtext="No Stop Time" ';
        }

        attr = attr + ' data-type="'    + 'wky'     + '"';
        attr = attr + ' data-id="'      + item.id   + '"';
        attr = attr + ' data-name="'    + item.name + '"';
        attr = attr + ' data-tdid="'    + tc._id    + '"';
        attr = attr + ' data-tcname="'  + tc._name  + '"';
        attr = attr + ' data-dir="'     + dir       + '"';

        html = html + '<option ' + attr + ' value="' + item.id +  '">' + item.name + ' (' + dir + ')' + '</option>\n';
      }

      html = html + '</optgroup>\n';
    }

    html = html + '</select>';

    $(selectId).empty();
    $(selectId).html(html);

    /*
     * wait for the DOM elements to be present, before we try to make the selectpicker...
     *
     */


    Logger.debug('[dwell/table]', 'waiting for <select> DOM to be ready...');

    function waitForRender(time: DOMHighResTimeStamp): void {

      /*
       * instead of trying to do a timeout on the existence of the DOM, we check
       * if it exists AND has a rendered geometry...if not we just request an
       * animation frame. It will typically only take a couple of frames before
       * it gets rendered; Javascript is single threaded, so Angular or whatever
       * will do all of its jazz, and this element will popup in the next frame.
       *
       */

      if ($(selectId).length == 0) {

        /* the window container has not even been created */

        window.requestAnimationFrame(waitForRender);

        /* keep waiting */

        return ;
      }

      Logger.debug('[dwell/table]', ' <select> is ready, setting up behaviors...');

      // @ts-ignore
      $.fn.selectpicker.Constructor.BootstrapVersion = '4';

      $(selectId).selectpicker({
        showTick: true,
        size: 20,
        windowPadding: [40, 0, 0, 0],
        style: 'btn btn-secondary',

      });

      Logger.debug(`[dwell/table] registering <select> click handler on ${selectId} .. button.dropdown-toggle ...`);

      $(`${selectId}`).nextAll(`button.dropdown-toggle`).click((e) => {

        Logger.debug(`[dwell/table] toggling train picker...`);

        const     el: any = $(`${selectId}`).nextAll(`.dropdown-menu`);
        const button: any = $(`${selectId}`).nextAll(`button.dropdown-toggle`);

        button.trigger('click.bs.dropdown.data-api');

        e.preventDefault();

      });

      $(selectId).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {

        Logger.debug(`[dwell/table] train selected (${clickedIndex}): `, e);

        dwt.refreshTable();

        e.stopPropagation();
        e.preventDefault();

      });

      /* default train template is just the first in the list */

      let  sel: any             = '';
      const todo: HTMLElement[] = $(`${selectId} option`).toArray();

      for (const el of todo) {

        const d  = $(el).attr('disabled');

        if (typeof d !== typeof undefined) {

          /* this one is disabled */

          continue;
        }

        /* this one is not disabled */

        sel = $(el).data('id');

        break;
      }

      Logger.debug(`[dwell/table] selecting first train: `, sel);

      $(selectId).selectpicker('val', sel);

      /* refresh the table based on currently selected train template */

      // this.refreshTable();

      /* all done */

      Logger.debug('[dwell/table]', ' <select> setup is complete.');

    }

    window.requestAnimationFrame(waitForRender);

    return true;
  }

  /** @brief helper to update the table w.r.t. a chosen train class */
  public refreshTable(): boolean {

    const selected: string[] = $(`#dwell-train-picker_${this.uuid}`).selectpicker('val') || [];
    const trains: Train[]    = [];

    Logger.debug('[dwell/table] new train list: ', selected);

    /* convert the train ids to trains */

    {
      for (const tidRaw of selected) {

        const tid: number = parseInt(tidRaw, 10);

        if (isNaN(tid)) {

          Logger.error('[dwell/table]', 'unusable train id: ', tidRaw);

          continue;
        }

        const train: Train = this._scenario.trainById(tid);

        if (train == null) {

          Logger.error('[dwell/table]', 'can not find train: ', tidRaw);

          continue;
        }

        /* it's a keeper */

        trains.push(train);
      }
    }

    Logger.debug('[dwell/table]', 'refreshing table: ...');

    /* build column defs... */

    this.columnDefs = [];
    this.rowData    = [];

    this.columnDefs.push({
      headerName: 'Decision Point',
        children: [
          {headerName: 'ROW',         field: 'row',      hide: true},
          {headerName: 'Mileage',     field: 'mileage',  editable: true, width: 150},
          {headerName: 'Name',        field: 'name',     editable: true, width: 150, columnGroupShow: 'open'},
          {
                  headerName: 'Type',
                       field: 'type',
                    editable: true,
                       width: 50,
                  cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
              values: ['S', 'D', 'P', 'T', 'J']
            },
             columnGroupShow: 'open'
        }
      ]
    });

    this.api.setGridOption('rowData', []);
    this.api.setGridOption('columnDefs', this.columnDefs);


    if (trains.length === 0) {

      Logger.debug('[dwell/table]', 'no selected trains.');

      return false;
    }

    /* fetch the bulk stop report for all chosen trains */

    const report: TrainStopReport[] = this._scenario.reportStops(trains);

    if (report.length === 0) {

      Logger.debug('[dwell/table]', 'empty report.');

      return true;
    }

    /*
     * for each train, there will be one stop group, and then a set of activity columns.  We
     * unique'ify the stop group by the train id, and for events we use the train id plus the
     * the event id.
     *
     */

    /* build out the column definitions ... */

    let  maxEvent: number = 1;

    for (const trainReport of report) {

      const       ss: string          = '_' + trainReport.train._id + '_' + 1; /* only one stop per DP */
      const stopGroup: any = {
        headerName: trainReport.train._name + ' (' + TrainClass.typeToString(trainReport.train._tc._dir) + ') ' + trainReport.totalTime,
        children: [
          {
            headerName: 'Stop 1',
            children: [
              {headerName: 'DPID',               field: 'dpid' + ss,      hide: true},
              {headerName: 'Time',               field: 'time' + ss,      editable: true, width: 150},
              {headerName: 'Stop Name',          field: 'stopname' + ss,  editable: true, width: 150, columnGroupShow: 'open'},
              {headerName: 'Earliest Departure', field: 'depart' + ss,    editable: true, width: 150, columnGroupShow: 'open'},
              {headerName: 'Sequence',           field: 'seq' + ss,       editable: true, width: 150, columnGroupShow: 'open'},
              {headerName: 'Clears Main',        field: 'cm' + ss,        editable: true, width: 150, columnGroupShow: 'open'},
              {headerName: 'Stops on Link',      field: 'sol' + ss,       editable: true, width: 150, columnGroupShow: 'open'}
            ]
          }
        ]
      };

      /* pre-scan the stops for this train to find the max activity columns we have to allow for */

      for (const stopEntry of trainReport.stops) {

        if (stopEntry.stop == null) {
          continue;
        }

        if (stopEntry.stop._events.length > maxEvent) {
          maxEvent = stopEntry.stop._events.length;
        }
      }

      /* now that we know the most events this train will have, we can push that many event subgroups */

      for (let si = 1; si <= maxEvent; si++) {

        const es: string = ss + '_' + si;

        stopGroup.children.push({
          headerName: 'Event ' + si,
          children: [
            {
              headerName: 'Type',
              field: 'type' + es,
              editable: true,
              width: 150,
              cellEditor: 'agSelectCellEditor',
              cellEditorParams: {
                values: ['Crew Change', 'Power Change', 'Work Event', 'PSG Stop', 'Other', 'Unknown', '.']
              }
            },
            {headerName: 'Prob Stop',   field: 'chance'    + es, editable: true, width: 150, columnGroupShow: 'open'},
            {headerName: 'Prob Short',  field: 'short'     + es, editable: true, width: 150, columnGroupShow: 'open'},
            {headerName: 'Min',         field: 'min_hour'  + es, editable: true, width: 150, columnGroupShow: 'open'},
            {headerName: 'Mean',        field: 'mean_hour' + es, editable: true, width: 150, columnGroupShow: 'open'},
            {headerName: 'Stdev Long',  field: 'dev_long'  + es, editable: true, width: 150, columnGroupShow: 'open'},
            {headerName: 'Stdev Short', field: 'dev_short' + es, editable: true, width: 150, columnGroupShow: 'open'}
          ]

        });

      } /* end of event group generation */

      /* the consist data for this train */

      stopGroup.children.push({
        headerName: 'Consist',
        children: [
          {headerName: 'SCID',     field: 'scid'     + ss, hide: true},
          {headerName: 'Class',    field: 'class'    + ss, editable: true, width: 150},
          {headerName: 'Tonnage',  field: 'tonnage'  + ss, editable: true, width: 150, columnGroupShow: 'open'},
          {headerName: 'Length',   field: 'length'   + ss, editable: true, width: 150, columnGroupShow: 'open'},
          {headerName: 'Priority', field: 'priority' + ss, editable: true, width: 150, columnGroupShow: 'open'},
          {headerName: 'Overtake', field: 'overtake' + ss, editable: true, width: 150, columnGroupShow: 'open'}
        ]
      });

      /* save all the column definitions for this train */

      this.columnDefs.push(stopGroup);

    } /* end of train walk to define column groups per train */

    /* ok, set the columns! */

    this.api.setGridOption('columnDefs', this.columnDefs);

    /* fill in the data, # of decision points is the same for all trains */

    for (let rowIdx = 0; rowIdx < report[0].stops.length; rowIdx++) {

      /* the basic decision point info is the same for all trains, just take it from first train */

      const rd: any = {

        row:      rowIdx,
        mileage:  report[0].stops[rowIdx].mileage,
        name:     report[0].stops[rowIdx].name,
        type:     report[0].stops[rowIdx].type,
        dpid:     report[0].stops[rowIdx].dpId,
        time:     report[0].stops[rowIdx].time,

      };

      /* to build out per train groups of columns, we have to walk the trains */

      let totalStopTime: number          = 0.0;
      let      hadStops: boolean         = false;

      for (const trainReport of report) {

        const   ss: string          = '_' + trainReport.train._id + '_' + 1; /* only one stop per DP */
        const stop: Stop = trainReport.stops[rowIdx].stop;

        /* default the stop and consist columns */

        rd['dpid' + ss]     = '.';
        rd['time' + ss]     = '.';
        rd['stopname' + ss] = '.';
        rd['depart' + ss]   = '.';
        rd['seq' + ss]      = '.';
        rd['cm' + ss]       = '.';
        rd['sol' + ss]      = '.';

        rd['scid' + ss]     = '.';
        rd['class' + ss]    = '.';
        rd['tonnage' + ss]  = '.';
        rd['length' + ss]   = '.';
        rd['priority' + ss] = '.';
        rd['overtake' + ss] = '.';

        /* default the event columns */

        for (let z2 = 1; z2 <= maxEvent; z2++) {

          const es: string        = ss + '_' + z2;

          rd['type' + es]      = '.';
          rd['chance' + es]    = '.';
          rd['short' + es]     = '.';
          rd['min_hour' + es]  = '.';
          rd['mean_hour' + es] = '.';
          rd['dev_long' + es]  = '.';
          rd['dev_short' + es] = '.';

        }

        /* now fill in general stop and consist data that we have */

        if (stop != null) {

          rd['dpid' + ss]       = trainReport.stops[rowIdx].dpId;
          rd['time' + ss]       = trainReport.stops[rowIdx].time;
          rd['stopname' + ss]   = stop._name;
          rd['depart' + ss]     = stop._depart;
          rd['seq' + ss]        = stop._sequence;
          rd['cm' + ss]         = stop._clears_main ? 'YES' : 'NO';
          rd['sol' + ss]        = stop._stops_on_link ? 'YES' : 'NO';

          totalStopTime        += trainReport.stops[rowIdx].hours;

          hadStops = true;

          /* fill in whatever event data we have */

          for (let z3 = 0; z3 < stop._events.length; z3++) {

            const event: StopEvent = stop._events[z3];
            const    es: string    = ss + '_' + (z3 + 1).toString();

            rd['type' + es]      = StopEvent.typeToString(event._type);
            rd['chance' + es]    = event._chance;
            rd['short' + es]     = event._short;
            rd['min_hour' + es]  = this._scenario.formatHours(event._min_hour);
            rd['mean_hour' + es] = this._scenario.formatHours(event._mean_hour);
            rd['dev_long' + es]  = event._dev_long;
            rd['dev_short' + es] = event._short;

          }

          if (stop._change != null) {

            rd['scid' + ss]     = stop._change._id;
            rd['class' + ss]    = stop._change._tc._name;
            rd['tonnage' + ss]  = stop._change._tonnage;
            rd['length' + ss]   = stop._change._length;
            rd['priority' + ss] = stop._change._priority;
            rd['overtake' + ss] = stop._change._overtake;

          }

        } /* end of general stop data */

      }

      if ((totalStopTime === 0) && (!hadStops)) {

        /* no point showing this decision point...nothing stops here */

        continue;
      }

      /* done building a single multi-train row (with column grouping) */

      this.rowData.push(rd);

    } /* end of data row generation */

    this.api.setGridOption('rowData', this.rowData);

    /* this.gridColumnApi.autoSizeAllColumns(); */

    /* for now use horizontal scroll, table is getting really wide */
    /* this.gridApi.sizeColumnsToFit(); */

    /* all done */

    return true;
  }

  @HostListener('window:resize')
  public resize() {

    Logger.debug('[dwell/table]', 'resizing...');

    /* for now use horizontal scroll, table is getting really wide */
    /* this.gridApi.sizeColumnsToFit(); */
  }

}
